import type { PostSubscriptionPreviewRequestBody } from '../schema-overrides';
export type { PostSubscriptionPreviewRequestBody } from '../schema-overrides';

export function bodySerializer(body: PostSubscriptionPreviewRequestBody): string {
  return JSON.stringify(body);
}
